module.exports = __webpack_public_path__ + "img/cna_career.5d58f608.jpg";